"use client";

import * as React from "react";
import { NavMain } from "@/shared/components/ui/nav-main";
import { NavSecondary } from "@/shared/components/ui/nav-secondary";
import { NavUser } from "@/shared/components/ui/nav-user";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarHeader,
} from "@/shared/components/ui/sidebar";
import { useTranslation } from "react-i18next";
import {
  navMainItems,
  settingsNavItems,
} from "@/shared/constants/navbar-list-items/layouts-list-items";
import Logo from "@/shared/components/logo/logo";
import { getDashboardLink } from "@/shared/utils/link";
import { useSelector } from "@/core/redux/store";
import { Separator } from "@/shared/components/ui/separator";
import { useEffect, useState } from "react";

export function DashboardSidebar({
  ...props
}: React.ComponentProps<typeof Sidebar>) {
  const me = useSelector((state) => state.user.me);
  const unreadInboxCount = useSelector((state) => state.user.unreadInboxCount);
  const { t } = useTranslation();
  const [data, setData] = useState({
    user: {
      name: t("email"),
      email: me?.email || "",
      avatar: "",
    },
    navMain: navMainItems(t),
    navSecondary: settingsNavItems(t),
  });

  useEffect(() => {
    setData({
      ...data,
      user: {
        name: t("email"),
        email: me?.email || "",
        avatar: "",
      },
      navSecondary: settingsNavItems(t),
    });
  }, [unreadInboxCount, me]);

  return (
    <div className="">
      <Sidebar variant="inset" {...props} className="">
        <SidebarHeader>
          <SidebarGroup className="">
            <div className="sidebar-logo px-2.5 py-2">
              <a href={getDashboardLink("")}>
                <Logo style={{ height: "34px !important" }} />
              </a>
            </div>
          </SidebarGroup>
        </SidebarHeader>
        <SidebarContent>
          <NavMain items={data.navMain} />
          <NavSecondary items={data.navSecondary} className="mt-auto" />
        </SidebarContent>
        <SidebarFooter>
          <Separator />
          <NavUser user={data.user} />
        </SidebarFooter>
      </Sidebar>
    </div>
  );
}
